import { useState, useEffect } from 'react';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../services/firebase.config';

interface User {
  uid: string;
  name: string;
  email: string;
  role: string;
}

export const useUserSearch = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchUsers = async (searchTerm: string) => {
    if (!searchTerm || searchTerm.length < 2) {
      setUsers([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const usersRef = collection(db, 'users');
      const q = query(
        usersRef,
        where('role', '==', 'user'),
        orderBy('name'),
        limit(10)
      );

      const querySnapshot = await getDocs(q);

      const usersData: User[] = [];

      querySnapshot.forEach((doc) => {
        const userData = doc.data();
        
        // Filtra per nome o email che contengono il termine di ricerca
        if (
          userData.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          userData.email?.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          usersData.push({
            uid: doc.id,
            name: userData.name || '',
            email: userData.email || '',
            role: userData.role || ''
          });
        }
      });

      setUsers(usersData);
    } catch (error) {
      console.error('Error searching users:', error);
      setError('Errore nella ricerca degli utenti');
    } finally {
      setLoading(false);
    }
  };

  const clearUsers = () => {
    setUsers([]);
  };

  return {
    users,
    loading,
    error,
    searchUsers,
    clearUsers
  };
}; 